import { Component, OnDestroy } from '@angular/core';
import { ModalController, NavParams, ToastController, ViewController, AlertController, Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { provider } from '../../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../../providers/customizer/customizer';

@Component({
  selector: 'page-variants',
  templateUrl: 'showVariants.html'
})
export class Variants {
  variants = [];
  max = 0;
  cont = 0;
  qty = 0;
  url: any;
  prod = '';

  constructor(public params: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public provider: provider,
    public customizer: CustomizerProvider,
    public translateService: TranslateService,
    public platform: Platform) {
    
    this.url = provider.getUrl();

    let tag = params.get('tag');

    this.max = tag.maxVariantsTag;
    this.prod = params.get('prod');
    this.variants = params.get('variants');

    this.controlQuantityPreviouslyEntered();

  }

  dismiss() {
    this.viewCtrl.dismiss([]);
  }

  addVar() {
    this.viewCtrl.dismiss(this.variants.filter((vars) => vars.quantita !== 0));
  }

  // controllo se c'è quantità inserita precedentemente
  controlQuantityPreviouslyEntered() {
    let totQty = 0;
    this.variants.forEach(element => {
      if(element.quantita == 1 || element.quantita == -1) 
        totQty++;
      else if(element.quantita !== 0)
        totQty = totQty + element.quantita;
    });
    if (totQty != 0)
      this.cont = totQty;
  }

  // aggiungere o togliere quantità alla variante
  increaseQty (item) {
    // controllo della quantità dell'ingrediente
    if ((!item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == 1) ||
        (item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == 1)) {
      return;
    }

    item.ofMandatoryIngredient = this.prod;

    if (item.quantita < 0) {
      item.quantita++;
      this.cont--;
    } else {
      if (this.cont != this.max) {
        item.quantita++;
        this.cont++;
      } else {
        this.alertMaxVariant();
      }
    }
  }

  decreaseQty (item) {
    // controllo della quantità dell'ingrediente
    if ((!item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == 0) ||
        (!item.extraProps.toglibile && item.extraProps.quantificabile && item.quantita == 0) ||
        (item.extraProps.toglibile && !item.extraProps.quantificabile && item.quantita == -1)) {
      return;
    }

    item.ofMandatoryIngredient = this.prod;

    // special check for ingredients with mandatoryIngredients set
    if (item.extraProps.isIngrediente && item.quantita == 0) {
      this.alertMinVariant();
    }
    else {
      if (item.quantita <= 0) {
        if (this.cont != this.max) {
          item.quantita--;
          this.cont++;
        }
        else {
          this.alertMaxVariant();
        }
      }
      else {
        item.quantita--;
        this.cont--;
      }
    }
  }

  alertMinVariant() {
    let alert = this.alertCtrl.create({
      title: 'Errore, limite raggiunto!',
      subTitle: 'Non puoi mettere a quantità negativa gli ingredienti di questo articolo !',
      buttons: ['OK']
    });
    alert.present();
  }

  alertMaxVariant() {
    let alert = this.alertCtrl.create({
      title: 'Errore, limite raggiunto!',
      subTitle: 'Non puoi aggiungere altre varianti!',
      buttons: ['OK']
    });
    alert.present();
  }

}


// WEBPACK FOOTER //
// ./src/pages/productDetail/showVariants/showVariants.ts